module.exports = __webpack_public_path__ + "static/media/9.3b3f7d6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/9.jpg
// module id = 96
// module chunks = 0